import(/* webpackMode: "eager" */ "/workspace/src/app/(app)/layout.tsx");
